/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _scrollViewport = __webpack_require__(1);
	
	var _scrollViewport2 = _interopRequireDefault(_scrollViewport);
	
	var _lazyLoad = __webpack_require__(4);
	
	var _lazyLoad2 = _interopRequireDefault(_lazyLoad);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	(0, _lazyLoad2["default"])();
	
	var $comFounded = $('#com-founded');
	var $comPower = $('#com-power');
	var $comCustomer = $('#com-customer');
	
	(0, _scrollViewport2["default"])('.screen', function ($screen) {
	  $screen.addClass('active').removeClass('disabled-animated');
	
	  if ($screen.hasClass('introduction')) {
	    var myDate = new Date();
	    var year = myDate.getFullYear() - 2009;
	    $comFounded.html(year);
	    $comPower.html('150');
	    $comCustomer.html('50');
	  }
	}, {
	  delayDistance: 50,
	  onLeave: function onLeave($screen) {
	    $screen.removeClass('active');
	
	    if ($screen.hasClass('introduction')) {
	      $comFounded.html('00');
	      $comPower.html('00');
	      $comCustomer.html('00');
	    }
	  }
	});
	// banner 轮播
	$(function () {
	  var $win = $(window);
	  var winW = $win.width();
	  // var $bannerWrap = $('.banner-wrap');
	  var $banner = $('.banner');
	  var $bannerItems = $('.banner .item');
	  var bannerLen = $bannerItems.length;
	  var autoSlide;
	  var curIndex = 0;
	  var $controls = $('.banner-wrap .banner-controls .item');
	
	  sizeBanner();
	  startAutoSlide();
	
	  $win.on('resize', function () {
	    sizeBanner();
	  });
	
	  $controls.on('click', function () {
	    var index = $(this).index() || 0;
	    slideTo(index);
	  });
	
	  $controls.on('mouseenter', stopAutoSlide);
	  $controls.on('mouseleave', startAutoSlide);
	
	  function startAutoSlide() {
	    if (!autoSlide) {
	      autoSlide = window.setInterval(slideItem, 5000);
	    }
	  }
	
	  function stopAutoSlide() {
	    if (autoSlide) {
	      window.clearInterval(autoSlide);
	      autoSlide = null;
	    }
	  }
	
	  function sizeBanner() {
	    winW = $win.width();
	    $banner.width(winW * bannerLen);
	    $bannerItems.width(winW);
	
	    slideTo(curIndex);
	  }
	
	  function slideItem() {
	    var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
	
	    slideTo((curIndex + direction) % bannerLen);
	  }
	
	  function slideTo() {
	    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	    curIndex = index;
	    var posLeft = -index * winW;
	
	    setControlActive(index);
	
	    $banner.animate({ left: posLeft + 'px' }, function () {
	      setBannerActive(index);
	    });
	  }
	
	  function setControlActive() {
	    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	    $controls.removeClass('active').eq(index).addClass('active');
	  }
	
	  function setBannerActive() {
	    var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	    $bannerItems.removeClass('active').eq(index).addClass('active');
	  }
	
	  // swiper
	  initSwiper();
	
	  function initSwiper() {
	    // 合作客户
	    var mySwiper = $('.customer-list-container').swiper({
	      loop: true,
	      slidesPerView: 7,
	      onlyExternal: true,
	      autoplay: 3000,
	      nextEl: '.swiper-button-next',
	      prevEl: '.swiper-button-prev'
	    });
	
	    console.log(mySwiper.slideNext);
	
	    $('.customer-list').on('mouseleave', function () {
	      mySwiper.startAutoplay();
	    }).on('mouseenter', function () {
	      mySwiper.stopAutoplay();
	    }).on('click', '.prev', function () {
	      mySwiper.swipePrev();
	    }).on('click', '.next', function () {
	      mySwiper.swipeNext();
	    });
	  }
	});
	
	initWiper();
	function initWiper() {
	  // 产品轮播
	  var myWiper = $('.menu-block-item').swiper({
	    loop: false,
	    slidesPerView: 5,
	    onlyExternal: true,
	    autoplay: 3000,
	    nextEl: '.swiper-button-next',
	    prevEl: '.swiper-button-prev'
	  });
	
	  console.log(myWiper.slideNext);
	
	  $('.menu-block').on('mouseleave', function () {
	    myWiper.startAutoplay();
	  }).on('mouseenter', function () {
	    myWiper.stopAutoplay();
	  }).on('click', '.prev1', function () {
	    myWiper.swipePrev();
	  }).on('click', '.next1', function () {
	    myWiper.swipeNext();
	  });
	}

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isInViewport = isInViewport;
	exports["default"] = scrollViewport;
	/**
	 * @requires jQuery
	 * @author Tianyz
	 */
	var $window = $(window);
	
	/**
	 * 判断元素是否进入可见区域
	 * 不用兼容 IE8 的话可以用 getBoundingClientRect 实现
	 * @param  {object}  $elm           dom 对象
	 * @param  {number}  delayDistance  延长距离
	 * @return {Boolean}
	 */
	function isInViewport($elm) {
	  var delayDistance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  var elmTop = $elm.offset().top;
	  var elmBottom = elmTop + $elm.outerHeight();
	  var screenTop = $window.scrollTop();
	  var screenBottom = screenTop + $window.height();
	
	  if (screenBottom > elmTop + delayDistance && screenTop < elmBottom) {
	    return true;
	  }
	
	  return false;
	}
	
	/**
	 * 监听元素进入可视区域的状态
	 * @param  {string}   elmSelector 元素选择器
	 * @param  {function} onEnter     进入可视区域的回调 参数为 jQuery 对象
	 * @param  {hash} options       {
	 *                                delayDistance {number} 延长的触发距离，设为负数则为提前触发的距离
	 *                                onLeave       {function} 离开可视区域的操作
	 *                              }
	 * @return {null}
	 */
	function scrollViewport(elmSelector, onEnter, options) {
	  var defaultOptions = {
	    delayDistance: 0,
	    onLeave: null
	  };
	  var $targets = $(elmSelector);
	
	  // options = Object.assign(defaultOptions, options);
	  // 都是为了兼容 ie8
	  $.extend(defaultOptions, options);
	  options = defaultOptions;
	
	  function activeInViewport() {
	    // TODO: _.debounce
	    $targets.each(function () {
	      var $elm = $(this);
	
	      if (!isInViewport($elm, options.delayDistance)) {
	        if (typeof options.onLeave === 'function') {
	          options.onLeave($elm);
	        }
	      } else {
	        onEnter($elm);
	      }
	    });
	  }
	
	  activeInViewport();
	
	  $window.on('scroll', activeInViewport);
	}

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = lazyLoad;
	/**
	 * 图片延迟加载
	 * @requires jQuery
	 * @author Tianyz
	 */
	
	/**
	 * 图片延迟加载
	 * 从元素的 data-img 中获取图片 url 进行显示设置
	 * @param  {String} [selector='.lzy-img'] 元素的 css 选择器
	 * @return {null}
	 */
	function lazyLoad() {
	  var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.lzy-img';
	
	  window.onload = function () {
	    $(selector).each(function () {
	      var $this = $(this);
	      var imgUrl = $this.data('img');
	
	      if (selector.charAt() === '.') {
	        $this.removeClass(selector.substring(1));
	      }
	
	      if (!imgUrl) {
	        return;
	      }
	
	      if (this.tagName.toUpperCase() === 'IMG') {
	        $this.attr('src', imgUrl);
	      } else {
	        $this.css('background-image', 'url(' + imgUrl + ')');
	      }
	    });
	  };
	}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js